module.exports = __webpack_public_path__ + "img/3d-printer.334f2472.svg";